import React, { Component, Fragment } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPhone} from '@fortawesome/free-solid-svg-icons'

import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLocation } from '@fortawesome/free-solid-svg-icons'
import RestClient from '../../RestAPI/RestClient'
import AppUrl from '../../RestAPI/AppUrl';


export class Contact extends Component {
  
  sendContact(){
   let name = document.getElementById("name").value;
      let phone = document.getElementById("phone").value;
        let message = document.getElementById("message").value;
          let email = document.getElementById("email").value;
         // alert(name+'/'+email+'/'+message+'/'+phone);

          let jsonObject ={name:name,phone:phone,message:message,email:email }
       
       RestClient.PostRequest(AppUrl.Contact,JSON.stringify(jsonObject)
      ).then(result=>{
        alert(result);
      }).catch(error=>{
        alert("Error");
      })
      
      



  }


  render() {
    return (
      <Fragment>
        <Container className='mt-5 mb-5'>
            <Row>
                <Col lg={6} md={6} sm={12}>
                <h1>Quick Contact</h1>
                <Form>
      <Form.Group className="mb-3" >
        <Form.Label>Your Name</Form.Label>
        <Form.Control id="name" type="text" placeholder="Enter Your Name" />
       
      </Form.Group>

        <Form.Group className="mb-3" >
        <Form.Label>Phone</Form.Label>
        <Form.Control id="phone" type="text" placeholder="Enter your Phone Number" />
       
      </Form.Group>


        <Form.Group className="mb-3" >
        <Form.Label>Message</Form.Label>
        <Form.Control id='message' as="textarea" rows={3} placeholder="Share your thoughts" />
        
      </Form.Group>

        <Form.Group className="mb-3" >
        <Form.Label>Email address</Form.Label>
        <Form.Control id='email' type="email" placeholder="Enter email" />
        <Form.Text className="text-muted">
          We'll never share your email with anyone else.
        </Form.Text>
      </Form.Group>

      
     
      <Button onClick={this.sendContact} variant="primary" >
        Submit
      </Button>
    </Form>


                </Col>
                <Col lg={6} md={6} sm={12}>
                <h1>Discuss Now</h1>
                
                      <p className='footerName '> <FontAwesomeIcon icon={faLocation}  ></FontAwesomeIcon>  37 Pharmacy Ave, M1K 1B9
                       <br></br>   <FontAwesomeIcon icon={faEnvelope} ></FontAwesomeIcon>  Email: Supportbd@gmail.Com
                       <br />   <FontAwesomeIcon icon={faPhone}  ></FontAwesomeIcon>  Phone: 4379980490 </p>

                </Col>
            </Row>
        </Container>
      </Fragment>
    )
  }
}

export default Contact
